export const deleteTraineePosition = (payload: { id: string }) => ({
    type: "@saga/DELETE_TRAINEE_POSITION",
    payload
});

